import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dice-4",
  "use": "icon-dice-4-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" class=\"bi bi-dice-4\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-dice-4\">\r\n  <path fill-rule=\"evenodd\" d=\"M13 1H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zM3 0a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3H3z\" />\r\n  <circle cx=\"4\" cy=\"4\" r=\"1.5\" />\r\n  <circle cx=\"12\" cy=\"4\" r=\"1.5\" />\r\n  <circle cx=\"12\" cy=\"12\" r=\"1.5\" />\r\n  <circle cx=\"4\" cy=\"12\" r=\"1.5\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/dice-4.svg
// module id = Ypag
// module chunks = 60